<template>
    <div>
        <div class="custom-card">           

             <div class="">
                <div class="">                   
                    <div class="col-md-4 col-lg-4 col-12 ">
                        <h2 class="text-[20px] font-bold text-[#080056]">KYC</h2>
                    </div>                 
                </div>
            </div> 

            <hr class="mb-2 mt-2" />

             <div class="">
                <div class=" rounded-xl bg-[#F2F7FC] border border-[0.5px] px-4 py-4 flex justify-between items-center bg-[#00000] border border-[2px]">
                    <div class="kyc ">
                        <p class="text-[16px] font-normal text-[#383F51]">We need you to complete a KYC (Know Your Customer) verification for your logistics business to help us:</p>
                        <p class="text-[16px] font-normal text-[#383F51] mt-4 mb-4">1. Confirm the legal status of your 3PL business and identify the beneficial owners. This 
                        applies whether your business is registered or operating as an individual. Beneficial
                         owners are individuals who have significant control or ownership of the business.</p> 
                        <p class="text-[16px] font-normal text-[#383F51]">2. Verify that your 3PL has the required and valid licenses to operate within your service 
                        locations.</p>
                        <p class="text-[16px] font-normal text-[#383F51] mt-4">Your KYC must be completed and approved before your 3PL profile can be activated or 
                        made visible on our platform.</p>     
                    </div>
                    <div class="">
                        <img class="w-[100%] h-[100%]"  src="../../../../../../assets/images/settings/desktop computer.svg" alt="">    
                    </div>                  
                </div>

              <div class="">

                    <div class="tab-cover">
                        <Tabs />
                    </div>

                </div>

            </div> 
        </div>

        <update-password-modal :show-modal="showPasswordModal" @close-modal="showPasswordModal = false" />
        <password-policy-modal :show-modal="showPolicyModal" @close-modal="showPolicyModal = false" />
        <security-question-modal :show-modal="showSecurityQuestionModal"
            @close-modal="showSecurityQuestionModal = false" />
        <two-factor-modal :show-modal="showTwoFactorModal" @close-modal="showTwoFactorModal = false" />

    </div>
</template>

<script>
import Tabs from './Tabs.vue';

export default {
  components: {
    Tabs,
  },
 
};

</script>

<style lang="scss" scoped>
.kyc{
    width: 75%;  
}

</style>
